import React from 'react';
import { DepartmentItem } from './DepartmentItem';
import { Departments } from './index.types';

type Props = {
  departments: Departments;
};

export const DepartmentList = ({ departments }: Props) => {
  return (
    <>
      {Object.entries(departments).map(([name, jobs]) => (
        <DepartmentItem name={name} jobs={jobs} />
      ))}
    </>
  );
};
